import DataApi from '../DataApi';

/**
 * Meta Lead Ads settings — /api/watconnect/adsettings
 */
class AdSettingsApi extends DataApi {
  constructor() {
    super('watconnect/adsettings');
  }

  list(params = {}) {
    const qs = new URLSearchParams();
    if (params.page_id) qs.set('page_id', String(params.page_id).trim());
    if (params.form_id) qs.set('form_id', String(params.form_id).trim());
    if (params.id) qs.set('id', String(params.id).trim());
    const query = qs.toString();
    return this.fetchAll(query);
  }

  /** Single watconnect_ads_setting via ObjectModel.fetchRecords (limit 1). */
  fetchCurrent() {
    return this.get('/current');
  }

  getById(id) {
    return this.fetchById(id);
  }

  createRecord(data) {
    return this.create(data);
  }

  updateRecord(id, data) {
    return this.update(data, id);
  }

  deleteRecord(id) {
    return this.delete(id);
  }

  fetchFormQuestions(params = {}) {
    const qs = new URLSearchParams();
    if (params.adsSettingId) {
      qs.set('ads_setting_id', String(params.adsSettingId).trim());
    }
    if (params.page_id) {
      qs.set('page_id', String(params.page_id).trim());
    }
    if (params.form_id) {
      qs.set('form_id', String(params.form_id).trim());
    }
    return this.get(`/form_questions?${qs.toString()}`);
  }

  fetchWebhookUrl(id) {
    return this.get(`/${id}/webhook-url`);
  }
}

const adSettingsApi = new AdSettingsApi();
export default adSettingsApi;
export { AdSettingsApi };
